import React from 'react';

const ElevatorIcon = (props) => {
  return (
    <svg
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.5104 12.9651C8.22146 12.9651 8.79802 12.3886 8.79802 11.6775C8.79802 10.9665 8.22146 10.3899 7.5104 10.3899C6.79934 10.3899 6.22278 10.9665 6.22278 11.6775C6.22278 12.3886 6.79934 12.9651 7.5104 12.9651Z" fill="currentColor" />
      <path d="M8.95981 13.5092H6.06084C5.41807 13.5092 4.99999 14.3821 5.28749 15.1239L6.92281 19.3451C7.14463 19.9178 7.87601 19.9178 8.09783 19.3451L9.73316 15.1239C10.0207 14.3821 9.60257 13.5092 8.95981 13.5092Z" fill="currentColor" />
      <path d="M14.0039 12.9651C14.715 12.9651 15.2915 12.3886 15.2915 11.6775C15.2915 10.9665 14.715 10.3899 14.0039 10.3899C13.2926 10.3899 12.7163 10.9665 12.7163 11.6775C12.716 12.3886 13.2926 12.9651 14.0039 12.9651Z" fill="currentColor" />
      <path d="M15.4536 13.5092H12.5546C11.9119 13.5092 11.494 14.3821 11.7813 15.1239L13.4166 19.3451C13.6384 19.9178 14.3698 19.9178 14.5916 19.3451L16.227 15.1239C16.5142 14.3821 16.0964 13.5092 15.4536 13.5092Z" fill="currentColor" />
      <path d="M21.0075 23.3778H0V0L2.59751 0V20.7801H18.8319V0L21.0075 0V23.3778Z" fill="currentColor" />
      <path d="M4.93817 8.55903L3.89624 7.5167L7.51682 3.89612L10.9603 7.33996L9.91835 8.38229L7.51682 5.98077L4.93817 8.55903Z" fill="currentColor" />
      <path d="M13.8335 8.55903L10.39 5.11518L11.4319 4.07326L13.8335 6.47438L16.4117 3.89612L17.4541 4.93845L13.8335 8.55903Z" fill="currentColor" />
    </svg>
  );
};

export default ElevatorIcon;
